module.exports = __webpack_public_path__ + "img/image16.7c40eb67.webp";